import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/ShinglesList';

export default define`Shingles List`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/ShinglesList`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
